module.exports = __webpack_public_path__ + "img/avata1.ada3757c.png";